import React from 'react';
import { Grid, MenuItem, Select } from '@material-ui/core';
import { useFormikContext } from 'formik';

import { Label } from 'core/components/label';
import { CreditCardField } from 'offer/components/checkout/components/billing-information/credit-card-field';
import { ACHFields } from 'common/components/payment/ach-fields';

/**
 * Shared payment-method collection for the sweep-account setup and add-method forms.
 * Reuses the checkout Basis Theory elements so card/bank details are tokenized client
 * side and never touch our servers. Requires an ancestor BasisTheory + element-refs
 * provider and a Formik context carrying `paymentMethodType`.
 */
const PaymentMethodFields = () => {
  const { values, setFieldValue } = useFormikContext();

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Label type="infoLabel">Payment method type</Label>
        <Select
          fullWidth
          value={values.paymentMethodType}
          onChange={(event) => setFieldValue('paymentMethodType', event.target.value)}
          data-cy="sweep-payment-method-type"
        >
          <MenuItem value="card">Credit / debit card</MenuItem>
          <MenuItem value="us_bank_account">Bank account (ACH)</MenuItem>
        </Select>
      </Grid>
      <Grid item xs={12}>
        {values.paymentMethodType === 'us_bank_account' ? <ACHFields mode="light" /> : <CreditCardField />}
      </Grid>
    </Grid>
  );
};

export default PaymentMethodFields;
